import Button from 'components/shared/Button.styled';
import styled from 'styled-components';
import { color, fontSize, fontWeight, screen, spacing } from 'theme';

export const StyledEmpty = styled.div`
  margin-top: ${spacing('lg')};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('md')};
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('medium')};
  text-align: center;

  p {
    margin: 0;
  }

  @media (min-width: ${screen('md')}) {
    padding: ${spacing('lg')};
    margin-top: 0;
  }

  ${Button} {
    margin-top: ${spacing('lg')};
  }
`;

export const StyledEmptyIcon = styled.div`
  width: ${spacing('xl4')};
  height: ${spacing('xl4')};
  color: ${color('midnight_300')};
`;

export const StyledEmptyTitle = styled.p`
  && {
    font-size: ${fontSize('lg')};
    font-weight: ${fontWeight('black')};
    line-height: 1.2;
    color: ${color('text_subtle')};
    margin-bottom: ${spacing('md')};
  }
`;

export const StyledOfferAlertItem = styled.div`
  border-bottom: 1px solid ${color('midnight_200')};
  padding: ${spacing('md')} 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledOfferAlertItemContent = styled.div`
  flex: 1 1 auto;

  &:first-letter {
    text-transform: uppercase;
  }
`;
